// NOTE: NSAI-5820 — the result of a user-requested condense, and what a client
// says about it. Keep EContextCondenseStatus in sync with the server's copy in
// server/src/chat/types/chat-context.types.ts.
//
// The endpoint always answers 200: "condensing is off", "nothing new to
// condense" and "already running" are ordinary outcomes of pressing a button,
// not faults. Modelling them as statuses rather than HTTP errors is the same
// choice NSAI-5810 made for the fault card — a user who pressed a button we
// offered should never be shown a red box for it.

export enum EContextCondenseStatus {
  CONDENSED = "condensed",
  NOTHING_TO_CONDENSE = "nothing_to_condense",
  UNAVAILABLE = "unavailable",
  IN_PROGRESS = "in_progress",
  FAILED = "failed",
}

export interface IContextCondenseResult {
  status: EContextCondenseStatus;
  // NOTE: Messages actually folded into the summary. Zero on every status
  // except CONDENSED, and on CONDENSED it is what the SAVED summary gained —
  // so the sentence the user reads cannot claim more than was condensed.
  condensedMessageCount: number;
}

// NOTE: Literal union for the same reason the pressure and failure lifts use
// one: `t()` type-checks it, so a key missing from chat.json fails the build
// instead of showing a user raw key text.
export type TContextCondenseMessageKey =
  | "contextPressure.condensed"
  | "contextPressure.condenseNothing"
  | "contextPressure.condenseUnavailable"
  | "contextPressure.condenseInProgress"
  | "contextPressure.condenseFailed";

// NOTE: How the message should land. Three tones, not two: "nothing new to
// condense" and "condensing is off" are neither a win nor a fault — showing
// them in red would tell a user something broke when the chat is simply already
// as small as it gets. Only `failure` is worth alarming about, and only
// `success` means the chat actually has more room than it did.
export type TContextCondenseTone = "success" | "notice" | "failure";

export interface IContextCondenseView {
  tone: TContextCondenseTone;
  messageKey: TContextCondenseMessageKey;
  // NOTE: For the success copy's `{{count}}`.
  condensedMessageCount: number;
}
